var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09094 8L13.8984 3.1925L14.8898 2.20109C15.0361 2.05484 15.0361 1.81719 14.8898 1.67094L13.8291 0.610156C13.6828 0.463906 13.4452 0.463906 13.2989 0.610156L7.5 6.40906L1.70109 0.609687C1.55484 0.463438 1.31719 0.463438 1.17094 0.609687L0.109687 1.67047C-0.0365625 1.81672 -0.0365625 2.05438 0.109687 2.20063L5.90906 8L0.109687 13.7989C-0.0365625 13.9452 -0.0365625 14.1828 0.109687 14.3291L1.17047 15.3898C1.31672 15.5361 1.55437 15.5361 1.70062 15.3898L7.5 9.59094L12.3075 14.3984L13.2989 15.3898C13.4452 15.5361 13.6828 15.5361 13.8291 15.3898L14.8898 14.3291C15.0361 14.1828 15.0361 13.9452 14.8898 13.7989L9.09094 8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.921beffac8630070e61fef254e5116e4.svg";
export { ForwardRef as ReactComponent };